import React from 'react';
import { createBrowserRouter } from 'react-router-dom';

import NotFound from './components/NotFound';
import SellTicketsIntro from '../sell/components/SellTicketsIntro';
import CartStep1 from '../cart/components/steps/CartStep1';
import CartStep2 from '../cart/components/steps/CartStep2';
import SellStep1 from '../sell/components/steps/SellStep1';
import SellStep2 from '../sell/components/steps/SellStep2';
import SellStep3 from '../sell/components/steps/SellStep3';
import SellStep4 from '../sell/components/steps/SellStep4';
import SellStep5 from '../sell/components/steps/SellStep5';
import PrivateRoute from './components/PrivateRoute';

const router = createBrowserRouter([
    {
        path: '/sell',
        element: <SellTicketsIntro/>,
    },
    {
        path: '/sell/1',
        element: <PrivateRoute element={SellStep1} to={'/sell'} />,
    },
    {
        path: '/sell/2',
        element: <PrivateRoute element={SellStep2} to={'/sell'} />,
    },
    {
        path: '/sell/3',
        element: <PrivateRoute element={SellStep3} to={'/sell'} />,
    },
    {
        path: '/sell/4',
        element: <PrivateRoute element={SellStep4} to={'/sell'} />,
    },
    {
        path: '/sell/5',
        element: <PrivateRoute element={SellStep5} to={'/sell'} />,
    },
    {
        path: '/cart/checkout',
        element: <CartStep1/>,
    },
    {
        path: '/cart/checkout/1',
        element: <CartStep1/>,
    },
    {
        path: '/cart/checkout/2',
        element: <PrivateRoute element={CartStep2} to={'/cart/checkout/1'} />,
    },
    {
        path: '*',
        element: <NotFound/>,
    },
]);

export default router;
